import { useMemo } from 'react';
import styled from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import SocialBadge from '../baseStyledComponents/SocialBadge';
import { getDimensions } from '../../lib/getDimensions';
import { AvatarBadgeHolder } from './AvatarBadgeHolder';
import { AvatarEditOverlay } from '../baseStyledComponents/AvatarEditOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContentHolder = styled.div.withConfig({
  displayName: "AvatarContentWrapper__ContentHolder",
  componentId: "jut4ps-0"
})(["border-radius:", ";font-size:initial;", ";"], ({
  type
}) => type === 'productId' ? '3px' : '50%', ({
  $cssStyles
}) => $cssStyles);
export const AvatarContentWrapper = ({
  AvatarBadge,
  borderColor,
  borderStyle = 'none',
  borderWidth,
  children,
  backgroundColor,
  href,
  isEditable,
  size = 'sm',
  socialNetwork,
  type
}) => {
  const contentHolderProps = {
    'data-size': size,
    'data-test-id': 'content-holder',
    'data-type': type,
    'data-border-size': borderWidth,
    type
  };
  const cssMap = useMapTokenPropsToCSS({
    alignItems: 'center',
    borderColor,
    borderStyle,
    borderWidth,
    color: 'text-core-on-fill-default',
    display: 'flex',
    overflow: 'hidden',
    position: 'relative'
  });
  const cssStyles = useMemo(() => {
    const dimensions = getDimensions(size);
    return Object.assign({}, cssMap, dimensions, {
      backgroundColor
    });
  }, [size, cssMap, backgroundColor]);
  const avatarBadgeContent = useMemo(() => {
    if (AvatarBadge) {
      return /*#__PURE__*/_jsx(AvatarBadgeHolder, {
        AvatarBadge: AvatarBadge,
        size: size
      });
    } else if (socialNetwork) {
      return /*#__PURE__*/_jsx(SocialBadge, {
        socialNetwork: socialNetwork,
        size: size
      });
    }
    return null;
  }, [AvatarBadge, size, socialNetwork]);
  if (href) {
    return /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "content-holder-link",
      use: "unstyled",
      href: href,
      display: "flex",
      blockSize: "100%",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsxs(ContentHolder, Object.assign({}, contentHolderProps, {
        $cssStyles: cssStyles,
        children: [children, isEditable ? /*#__PURE__*/_jsx(AvatarEditOverlay, {}) : null]
      })), avatarBadgeContent]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ContentHolder, Object.assign({}, contentHolderProps, {
      $cssStyles: cssStyles,
      children: [children, " ", isEditable ? /*#__PURE__*/_jsx(AvatarEditOverlay, {}) : null]
    })), avatarBadgeContent]
  });
};